class LottieUtils {
  static ANIMATION_PROPERTIES = Object.freeze({
    loop: true
    , background: "transparent"
    , speed: 1.00
    , direction: 1.00
    , playMode: "normal"
    , autoplay: true
  });
}

export default LottieUtils;
